var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.checkPermi(["merchant:statistics:home:index"])
        ? _c("base-info", { ref: "baseInfo" })
        : _vm._e(),
      _c("grid-menu", { staticClass: "mb14" }),
      _c("ranking", { ref: "ranking" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }